export default __webpack_public_path__ + "static/media/Gafrico.2e00c829.svg";